import { render } from "./EventCard.vue?vue&type=template&id=df28a3a0&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=df28a3a0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-df28a3a0"

export default script